import { COOKIE_KEYS } from "../constants/cookies.const";
import Cookies from "js-cookie";

export const clearCookies = () => {
  Object.keys(COOKIE_KEYS).forEach((key) => {
    Cookies.remove(key);
  });
};
